import { usePlayer } from "../player/playerContext";
import { useQuery } from "react-query";
import fetchApi from "../backend/fetchApi";
import { FreeBet } from "../models/freebet";

const useFreebets = () => {
  const [player] = usePlayer() as any;
  const freebetUrl = player && player._links.freebets?.href
  const agents = useQuery<FreeBet[], unknown>(['freebets', freebetUrl], () => {

    if (freebetUrl === undefined) {
      return [];
    }

    return fetchApi(freebetUrl).then(response =>
      response.json()).then(r => r._embedded.freebets)
  }, {
    enabled: !!player,
  })

  return agents.data;
}

export default useFreebets;